<template>
  <div class="doomyogalogin doomyoga-auth-container">
    <div class="h-100">
      <div class="row h-100 m-0">
        <div class="col-xl-5 col-lg-5 col-md-6 col-sm-12 my-auto">
          <div class="book-class-summary">
            <b-container class="p-0 pm-2">
              <b-card class="card-login my-1 py-0">
                <img
                  :src="getImgUrl('doom-yoga/Doomyoga-logo.png')"
                  class="d-block mx-auto loginIconImg auth-logo-dy mb-4"
                />
                <h2 class="welecomeH6 welecomeDYH6 mt-4 mb-3">
                  Booking summary
                </h2>
                <b-row>
                  <b-col lg="10" class="mx-auto">
                    <b-card
                      class="card-book-summary-dy w-100 mx-auto mt-2 mb-2 p-2"
                      :title="event_title"
                    >
                      <b-card-text class="my-2">
                        {{ event_description }}
                      </b-card-text>

                      <b-row class="mb-1">
                        <b-col class="float-left"
                          ><b-card-text class="my-1">
                            {{ event_date }}
                          </b-card-text></b-col
                        >
                      </b-row>
                      <b-row class="mb-1">
                        <b-col class="float-left"
                          ><b-card-text class="my-1">
                            {{ event_location }}
                          </b-card-text></b-col
                        >
                      </b-row>
                      <b-row class="mb-3">
                        <!-- <b-col class="float-left"
                          ><b-card-text class="my-1">
                            {{ event_duration }}
                          </b-card-text></b-col
                        > -->

                        <b-col class="float-left"
                          ><b-card-text class="my-1">
                            {{ event_time }}
                          </b-card-text></b-col
                        >
                        <b-col class="float-right"
                          ><b-card-text class="float-right my-1">
                            {{ event_fees }}
                          </b-card-text></b-col
                        >
                      </b-row>

                      <b-row
                        ><b-col class="text-center">
                          <b-button
                            variant="secondary-auth-dy"
                            class="text-center"
                            @click="clickCancelEvent"
                            >Cancel</b-button
                          ></b-col
                        ></b-row
                      >
                    </b-card></b-col
                  ></b-row
                >
              </b-card>
              <div class="d-flex justify-content-center align-content-center">
                <!-- <button
                  class="btn btn-login-dy"
                  type="button"
                  @click="clickProceedCheckout"
                  v-if="login_user != null"
                >
                  Proceed to checkout
                </button> -->
                <button
                  class="btn btn-login-dy"
                  type="button"
                  @click="clickBookEvent"
                  v-if="login_user != null && !is_loading"
                >
                  Book
                </button>
                   <b-button
            type="button"
            disabled
             class="btn btn-login-dy"
           
            v-else-if="login_user != null && is_loading"
          >
            <b-spinner small label="Small Spinner" variant="light"></b-spinner>
            Loading
          </b-button>
                <button
                  class="btn btn-login-dy"
                  type="button"
                  @click="clickProceedBooking"
                 v-else-if="login_user == null"
                >
                  Proceed with booking
                </button>
              </div>
            </b-container>
          </div>
        </div>
        <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12 my-auto">
          <div class="container" id="doomYogaImdDiv">
            <img
              class="img-fluid mx-auto"
              id="doomYogaLoginImg"
              src="@/assets/images/doom-yoga/doom-yoga-login-image2.png"
              alt="doomyoga Logo"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";

export default {
  name: "DoOmYogaCustomerEventsBookSummary",
  components: {},
  data() {
    return {
      login_user: window.localStorage.getItem("user"),
      event_title: null,
      event_description: null,
      event_duration: null,
      event_fees: null,
      event_date: null,
      event_time: null,
      event_location: null,
      event_id: null,
      is_loading: false
    };
  },
  mounted() {
    console.log(
      "in book summary ",
      window.sessionStorage.getItem("selected_date")
    );

    this.event_date = window.sessionStorage.getItem("selected_date");
    this.event_time = window.sessionStorage.getItem("selected_slot");
    this.event_id = window.sessionStorage.getItem("selected_class");
    console.log(this.event_date, this.event_time, this.event_id);
    this.getEventData(this.event_id);
  },
  updated() {},
  watch() {},
  methods: {
    getImgUrl(imgname) {
      // var images = require.context("@/assets/images/", false, /\.png$/);
      // return images("./" + imgname );

      return require("@/assets/images/" + imgname);
    },
    getEventData(id) {
      console.log("get event data ", id);
      // this.event_title = '1 TO 1 DO.OMYOGA PRIVATE TUTORIAL'
      // this.event_description = 'Refine your practice with founder and teacher Kamellia Sara.'
      axios
        .get("event/session-event-details/" + id, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "DY",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          console.log(response.data);
          let event = response.data;
          this.event_title = event.name;
          this.event_description = event.description;
          this.eventdate = event.date;
          this.event_time = event.time;
          this.event_location = event.address;
          if (event.price == null) {
            this.event_fees = "Free";
          } else {
            this.event_fees = "£" + event.price;
          }

          // callback(response.data);
        });
    },
    clickBookEvent() {
      console.log(
        "click book event",
        this.event_id,
        JSON.parse(this.login_user).id
      );
      this.is_loading = true
       let formData = new FormData();
          formData.append("client", 'DY');
          formData.append("type", 'session');
          formData.append("id[]", this.event_id);
      axios
        .post("event/join-event", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "client": "DY",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: response.data.success,
            type: "success",
            timer: 3000,
            customClass: {
              container: "swal-alert-doomyoga",
              confirmButton:
                "btn btn-bumblebee btn-doomyoga btn-doomyoga-primary btn-doomyoga-submit",
              cancelButton:
                "btn btn-bumblebee btn-doomyoga btn-doomyoga-danger-outline btn-doomyoga-submit",
            },
          }).then((r) => {
            // console.log(r.value); 
            this.$router.push({ name: "DoOmYogaCustomerEventsCalendar" });
          });
          this.is_loading = false;
          // this.$router.go();
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            // timer: 3000,
            customClass: {
              container: "swal-alert-doomyoga",
              confirmButton:
                "btn btn-bumblebee btn-doomyoga btn-doomyoga-primary btn-doomyoga-submit",
              cancelButton:
                "btn btn-bumblebee btn-doomyoga btn-doomyoga-danger-outline btn-doomyoga-submit",
            },
          }).then((r) => {
            // console.log(r.value);
          });
          this.is_loading = false
        });

      // this.$fire({
      //   // title: "Title",
      //   text: "Event is booked successfully ",
      //   type: "success",

      //   timer: 3000,
      // }).then((r) => {
      //   console.log(r.value);
       
      // });
    },
    clickProceedCheckout() {
      console.log("click proceed checkout ");

      this.$router.push({ name: "DoOmYogaCustomerEventsBookPayment" });
    },
    clickProceedBooking() {
      console.log("click proceed booking ");

      this.$router.push({ name: "DoOmYogaCustomerEventsBookAsGuest" });
    },
    clickCancelEvent() {
      window.sessionStorage.setItem("is_cancel", true);
      // alert( moment(this.event_date).format("YYYY-MM-DD"))
      window.sessionStorage.setItem(
        "initialDate",
        moment(this.event_date).format("YYYY-MM-DD")
      );
      this.$router.push({ name: "DoOmYogaCustomerEventsCalendar" });
    },
  },
};
</script>

<style  scoped::v-deep>
@import "../../css/doom-yoga-fonts.css";
@import "../../css/doom-yoga-auth-styles.css";
</style>



// WEBPACK FOOTER //
// src/components/doom_yoga/customer/Events/BookSummary.vue